import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Dashboard from '../pages/Dashboard'
import PrivateRoute from './PrivateRoute'
import Login from "../pages/Login"
import schoolList from '../pages/schoolList'
// import AddSchool from '../pages/AddSchool'
import AddBoardManager from '../pages/AddBoardManager'
import ForgotPassword from '../pages/ForgotPassword'
import Verification from '../pages/Verification'
import ResetPassword from '../pages/ResetPassword'
import SuccessMessage from '../pages/SuccessMessage'
import SignUp from '../pages/Sign-Up/SignUp'
import VerificationSignUp from '../pages/Sign-Up/VerificationSignUp'
import BoardManagementMain from '../components/common/BoardManagementMain'
import Board_List from '../pages/Board-Management/Board_List'
import Board_List_old from '../pages/Board_List'
import ViewMember from '../pages/Board-Management/View_Member'
import Add_Member from '../pages/Board-Management/Add_Member'
import Add_Note from '../pages/Board-Management/Add_Note'
import School_List from '../pages/School-Management/School_List'
import View_Member from '../pages/School-Management/View_Member'
import Add_School_Member from '../pages/School-Management/Add_Member'
import Add_School_Note from '../pages/School-Management/Add_Note'
import Admissions_main from '../pages/Admission/Admissions_main'
import Faqs_List from '../pages/Admission/Faqs_List'
import Add_faqs from '../pages/Admission/Add_faqs'

import Teacher_List from '../pages/teacher-Management/Teacher_List'
import Teacher_View_Member from '../pages/teacher-Management/Teacher_View_Member'
import Add_teacher_Member from '../pages/teacher-Management/Add_Member'
import Add_teacher_Note from '../pages/teacher-Management/Add_Note'



import EducationMain from '../pages/Education/EducationMain'
import Add_performance from '../pages/Education/Add_performance'
import Add_subject from '../pages/Education/Add_subject'
import Add_stream from '../pages/Education/Add_stream'
import Add_project from '../pages/Education/Add_project'
import Add_facility from '../pages/Education/Add_facility'
import View_facilities from '../pages/Education/View_facilities'
import NewsManagement_main from '../pages/News-Management/NewsManagement_main'
import Add_news from '../pages/News-Management/Add_news'
import View_news from '../pages/News-Management/View_news'
import Department_main from '../pages/Department/Department_main'
import Add_department from '../pages/Department/Add_department'
import View_department from '../pages/Department/View_department'
import Extracurricular_main from '../pages/Extracurricular/Extracurricular_main'
import Add_sports from '../pages/Extracurricular/Add_sports'
import Add_arts from '../pages/Extracurricular/Add_arts'
import Add_clubs from '../pages/Extracurricular/Add_clubs'
import Add_leadership from '../pages/Extracurricular/Add_leadership'
import Add_religious from '../pages/Extracurricular/Add_religious'
import Add_volunteering from '../pages/Extracurricular/Add_volunteering'
import View_sports from '../pages/Extracurricular/View_sports'
import View_arts from '../pages/Extracurricular/View_arts'
import View_club from '../pages/Extracurricular/View_club'
import View_leadership from '../pages/Extracurricular/View_leadership'
import View_religious from '../pages/Extracurricular/View_religious'
import View_volunteering from '../pages/Extracurricular/View_volunteering'
import View_project from '../pages/Education/View_project'
import School_profile from '../pages/School_profile'
import Roles from '../pages/Roles-permission/Roles'
import Add_role from '../pages/Roles-permission/Add_role'
import Admin_main from '../pages/School-Admin-Management/Admin_main'
import Add_admin from '../pages/School-Admin-Management/Add_admin'
import Settings_Main from '../pages/Settings/Settings_Main'
import AdminDashboard from '../pages/AdminDashboard'
import SchoolApprovalList from '../pages/Approval/SchoolApprovalList'
import SchoolReview from '../pages/Approval/SchoolReview'
import SchoolList from '../pages/Super-Admin/SchoolList'
import AddSchool from '../pages/Super-Admin/AddSchool'
import ViewSchool from '../pages/Super-Admin/ViewSchool'
import ContentMain from '../pages/Super-Admin/Cms/ContentMain'
import AddContent from '../pages/Super-Admin/Cms/AddContent'
import { RoliList } from '../pages/Super-Admin/Role and Permission/RoliList'
import AddRole from '../pages/Super-Admin/Role and Permission/AddRole'
import AdminList from '../pages/Super-Admin/Role and Permission/AdminList'
import AddAdmin from '../pages/Super-Admin/Role and Permission/AddAdmin'
import ActivityLogs from '../pages/Super-Admin/ActivityLogs'

const AllRoutes = () => {
  return (
    <Router forceRefresh>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/verify' element={<Verification />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path='/sussess' element={<SuccessMessage />} />
        <Route path='/school-signUp' element={<SignUp />} />
        <Route path='/signUp-verify' element={<VerificationSignUp />} />
        <Route path='/dashboard' element={<PrivateRoute Component={Dashboard} />} />
        {/* school  */}
        {/* <Route path='/school' element={<PrivateRoute Component={schoolList}/>}/>
            <Route path='/school/add' element={<PrivateRoute Component={AddSchool}/>}/>
            <Route path='/school/edit/:id' element={<PrivateRoute Component={AddSchool}/>}/> */}
        <Route path='/profile' element={<PrivateRoute Component={School_profile} />} />

        {/* board management  */}
        <Route path='/board-management' element={<PrivateRoute Component={Board_List} />} />
        <Route path='/board-management/view/:id' element={<PrivateRoute Component={ViewMember} />} />
        <Route path='/board-management/add-member' element={<PrivateRoute Component={Add_Member} />} />
        <Route path='/board-management/edit-member/:id' element={<PrivateRoute Component={Add_Member} />} />
        <Route path='/board-management/add-note' element={<PrivateRoute Component={Add_Note} />} />
        <Route path='/board-management/add-file' element={<PrivateRoute Component={Add_Note} />} />
        <Route path='/board-management/add-contribution' element={<PrivateRoute Component={Add_Note} />} />
        {/* <Route path='/board-management-old' element={<PrivateRoute Component={Board_List_old} />} /> */}
        {/* <Route path='/board-management/add' element={<PrivateRoute Component={AddBoardManager} />} /> */}
        <Route path='/board-management/edit/:id' element={<PrivateRoute Component={AddBoardManager} />} />


        {/* school Management */}
        <Route path='/school-management' element={<PrivateRoute Component={School_List} />} />
        <Route path='/school-management/view/:id' element={<PrivateRoute Component={View_Member} />} />
        <Route path='/school-management/add-member' element={<PrivateRoute Component={Add_School_Member} />} />
        <Route path='/school-management/edit-member/:id' element={<PrivateRoute Component={Add_School_Member} />} />
        <Route path='/school-management/add-note' element={<PrivateRoute Component={Add_School_Note} />} />
        <Route path='/school-management/add-file' element={<PrivateRoute Component={Add_School_Note} />} />
        <Route path='/school-management/add-contribution' element={<PrivateRoute Component={Add_School_Note} />} />

        {/* school Management */}
        <Route path='/teacher-management' element={<PrivateRoute Component={Teacher_List} />} />
        <Route path='/teacher-management/view/:id' element={<PrivateRoute Component={Teacher_View_Member} />} />
        <Route path='/teacher-management/add-member' element={<PrivateRoute Component={Add_teacher_Member} />} />
        <Route path='/teacher-management/edit-member/:id' element={<PrivateRoute Component={Add_teacher_Member} />} />
        <Route path='/teacher-management/add-note' element={<PrivateRoute Component={Add_teacher_Note} />} />
        <Route path='/teacher-management/add-file' element={<PrivateRoute Component={Add_teacher_Note} />} />
        <Route path='/teacher-management/add-contribution' element={<PrivateRoute Component={Add_School_Note} />} />

        {/* Admissions  */}
        <Route path='/admissions' element={<PrivateRoute Component={Admissions_main} />} />
        <Route path='/admissions/faqs' element={<PrivateRoute Component={Faqs_List} />} />
        <Route path='/admissions/faqs/add' element={<PrivateRoute Component={Add_faqs} />} />
        <Route path='/admissions/faqs/edit/:id' element={<PrivateRoute Component={Add_faqs} />} />

        {/* Education  */}
        <Route path='/education' element={<PrivateRoute Component={EducationMain} />} />
        <Route path='/education/performance/add' element={<PrivateRoute Component={Add_performance} />} />
        <Route path='/education/performance/edit/:id' element={<PrivateRoute Component={Add_performance} />} />
        <Route path="/education/subject/add" element={<PrivateRoute Component={Add_subject} />} />
        <Route path="/education/subject/edit/:id" element={<PrivateRoute Component={Add_subject} />} />
        <Route path='/education/streams/add' element={<PrivateRoute Component={Add_stream} />} />
        <Route path='/education/streams/edit/:id' element={<PrivateRoute Component={Add_stream} />} />
        <Route path="/education/projects/add" element={<PrivateRoute Component={Add_project} />} />
        <Route path="/education/projects/edit/:id" element={<PrivateRoute Component={Add_project} />} />
        <Route path='/education/projects/view/:id' element={<PrivateRoute Component={View_project} />} />
        <Route path='/education/facilities/add' element={<PrivateRoute Component={Add_facility} />} />
        <Route path='/education/facilities/edit/:id' element={<PrivateRoute Component={Add_facility} />} />
        <Route path='/education/facilities/view/:id' element={<PrivateRoute Component={View_facilities} />} />
        <Route path='/news-management' element={<PrivateRoute Component={NewsManagement_main} />} />
        <Route path='/news-management/add' element={<PrivateRoute Component={Add_news} />} />
        <Route path='/news-management/edit/:id' element={<PrivateRoute Component={Add_news} />} />
        <Route path='/news-management/view/:id' element={<PrivateRoute Component={View_news} />} />
        <Route path='/department' element={<PrivateRoute Component={Department_main} />} />
        <Route path='/department/add' element={<PrivateRoute Component={Add_department} />} />
        <Route path='/department/edit/:id' element={<PrivateRoute Component={Add_department} />} />
        <Route path='/department/view/:id' element={<PrivateRoute Component={View_department} />} />
        <Route path='/extracurricular' element={<PrivateRoute Component={Extracurricular_main} />} />
        <Route path='/extracurricular/sports/add' element={<PrivateRoute Component={Add_sports} />} />
        <Route path='/extracurricular/sports/edit/:id' element={<PrivateRoute Component={Add_sports} />} />
        <Route path='/extracurricular/sports/view/:id' element={<PrivateRoute Component={View_sports} />} />
        <Route path='/extracurricular/arts/add' element={<PrivateRoute Component={Add_arts} />} />
        <Route path='/extracurricular/arts/edit/:id' element={<PrivateRoute Component={Add_arts} />} />
        <Route path='/extracurricular/arts/view/:id' element={<PrivateRoute Component={View_arts} />} />
        <Route path='/extracurricular/clubs/add' element={<PrivateRoute Component={Add_clubs} />} />
        <Route path='/extracurricular/clubs/edit/:id' element={<PrivateRoute Component={Add_clubs} />} />
        <Route path='/extracurricular/clubs/view/:id' element={<PrivateRoute Component={View_club} />} />
        <Route path='/extracurricular/leadership/add' element={<PrivateRoute Component={Add_leadership} />} />
        <Route path='/extracurricular/leadership/edit/:id' element={<PrivateRoute Component={Add_leadership} />} />
        <Route path='/extracurricular/leadership/view/:id' element={<PrivateRoute Component={View_leadership} />} />
        <Route path='/extracurricular/religious/add' element={<PrivateRoute Component={Add_religious} />} />
        <Route path='/extracurricular/religious/edit/:id' element={<PrivateRoute Component={Add_religious} />} />
        <Route path='/extracurricular/religious/view/:id' element={<PrivateRoute Component={View_religious} />} />
        <Route path='/extracurricular/volunteering/add' element={<PrivateRoute Component={Add_volunteering} />} />
        <Route path='/extracurricular/volunteering/edit/:id' element={<PrivateRoute Component={Add_volunteering} />} />
        <Route path='/extracurricular/volunteering/view/:id' element={<PrivateRoute Component={View_volunteering} />} />

        {/* Role & Permissions */}

        <Route path='/role' element={<PrivateRoute Component={Roles} />} />
        <Route path='/role/add' element={<PrivateRoute Component={Add_role} />} />
        <Route path='/role/edit/:id' element={<PrivateRoute Component={Add_role} />} />

        {/* Admin Management */}

        <Route path='/subadmin' element={<PrivateRoute Component={Admin_main}/>}/>
        <Route path='/subadmin/add' element={<PrivateRoute Component={Add_admin}/>}/>
        <Route path='/subadmin/edit/:id' element={<PrivateRoute Component={Add_admin}/>}/>


        {/* Setting */}
        <Route path='/settings' element={<PrivateRoute Component={Settings_Main} />}/>



        
        {/* Super Admin  */}
        <Route path='/admin-dashboard' element={<PrivateRoute Component={AdminDashboard} />} />
        <Route path='/admin-approvals' element={<PrivateRoute Component={SchoolApprovalList} />} />
        <Route path='/school-approval/:id' element={<PrivateRoute Component={SchoolReview} />}/>
        <Route path='/admin-school' element={<PrivateRoute Component={SchoolList} />}/>
        <Route path='/admin-school/add' element={<PrivateRoute Component={AddSchool} />}/>
        <Route path='/admin-school/edit/:id' element={<PrivateRoute Component={AddSchool} />}/>
        <Route path='/admin-school/view/:id' element={<PrivateRoute Component={ViewSchool} />}/>

        <Route path='/admin-content' element={<PrivateRoute Component={ContentMain}/>} />
        <Route path='/admin-content/add' element={<PrivateRoute Component={AddContent}/>} />
        <Route path='/admin-content/edit/:id' element={<PrivateRoute Component={AddContent}/>} />
        

        <Route path='/admin-role' element={<PrivateRoute Component={RoliList}/>}/>
        <Route path='/admin-role/add' element={<PrivateRoute Component={AddRole}/>}/>
        <Route path='/admin-role/edit/:id' element={<PrivateRoute Component={AddRole}/>}/>
        <Route path='/admin-subadmin' element={<PrivateRoute Component={AdminList}/>}/>
        <Route path='/admin-subadmin/add' element={<PrivateRoute Component={AddAdmin}/>}/>
        <Route path='/admin-subadmin/edit/:id' element={<PrivateRoute Component={AddAdmin}/>}/>
        <Route path='/admin-activity' element={<PrivateRoute Component={ActivityLogs}/>}/>









      </Routes>
    </Router>
  )
}

export default AllRoutes